import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import DataTable from 'react-data-table-component';
import { API_BASE_URL } from '../../utils/api';
import Modal from 'react-modal';
import BackButton from '../../components/BackButton';

const ClientList = () => {
  const [clients, setClients] = useState([]);
  const [filteredClients, setFilteredClients] = useState([]);
  const [search, setSearch] = useState('');
  const [selectedClient, setSelectedClient] = useState(null);
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/clients`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setClients(res.data);
        setFilteredClients(res.data);
      } catch (err) {
        toast.error('Error fetching clients');
      }
    };
    fetchClients();
  }, [token]);

  useEffect(() => {
    const result = clients.filter(client =>
      client.name.toLowerCase().includes(search.toLowerCase())
    );
    setFilteredClients(result);
  }, [search, clients]);

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this client?')) return;

    try {
      await axios.delete(`${API_BASE_URL}/api/clients/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setClients(prev => prev.filter(client => client.id !== id));
      toast.success('Client deleted');
    } catch (err) {
      toast.error('Error deleting client');
    }
  };

  const columns = [
    {
      name: 'Photo',
      cell: row => (
        <img
          src={row.profilePicture ? `${API_BASE_URL}${row.profilePicture}` : '/default-avatar.png'}
          alt="Profile"
          className="w-10 h-10 rounded-full object-cover"
        />
      ),
      sortable: false,
      width: '120px',
    },
    {
      name: 'Name',
      selector: row => row.name,
      sortable: true,
      width: '230px',
      cell: row => (
        <span
          className="text-purple-400 hover:underline cursor-pointer"
          onClick={() => setSelectedClient(row)}
        >
          {row.name}
        </span>
      )
    },
    {
      name: 'Phone',
      selector: row => row.phone,
      sortable: true,
      width: '230px',
      cell: row => (
        <a
          href={`tel:${row.phone}`}
          className="flex items-center gap-1 text-blue-300 hover:text-blue-400"
          style={{ textDecoration: 'none' }}
        >
          📞 {row.phone}
        </a>
      )
    },
    
    
    {
      name: 'Plan Type',
      selector: row => row.planType,
      sortable: true,
      width: '230px',
      cell: row => <span className="capitalize">{row.planType}</span>
    },
    {
      name: 'Actions',
      width: '445px',
      cell: row => (
        <div className="flex gap-1">
          <button
            onClick={() => navigate(`/shifts/${row.id}`)}
            className="bg-[#8F4EFF] hover:bg-purple-700 text-white px-2 py-1 rounded text-sm"
          >
            Shifts
          </button>

          <button
            onClick={() => navigate(`/notes/${row.id}`)}
            className="bg-[#1c8b38] hover:bg-green-800 text-white px-2 py-1 rounded text-sm"
          >
            Notes
          </button>

          <button
            onClick={() => navigate(`/clients/edit/${row.id}`)}
            className="bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded text-sm"
          >
            Edit
          </button>
          <button
            onClick={() => handleDelete(row.id)}
            className="bg-red-500 hover:bg-red-600 text-white px-2 py-1 rounded text-sm"
          >
            Delete
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true
    }
  ];

  return (
    <div className="p-8 bg-[#0E0A1F] text-white  min-h-screen">
      <BackButton/>
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl font-bold mb-4">Client List</h2>
        <div className="flex justify-between mb-4 gap-4 flex-wrap">
          <button
            onClick={() => navigate('/clients/create')}
            className="bg-purple-600 px-4 py-2 rounded hover:bg-purple-700"
          >
            Add New Client
          </button>
          <input
            type="text"
            placeholder="Search by name..."
            className="p-3 rounded bg-[#2A1C4A] text-white placeholder-gray-400 w-full sm:w-64"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {/* <div className="bg-[#1C1235] p-4 rounded-xl"> */}
          <DataTable
            columns={columns}
            data={filteredClients}
            pagination
            responsive
            customStyles={{
              headCells: {
                style: {
                  backgroundColor: '#1C1235',
                  color: 'white',
                  fontWeight: 600,
                  borderBottom: '1px solid #3B2D5F',
                }
              },
              rows: {
                style: {
                  backgroundColor: '#0E0A1F',
                  color: 'white',
                  minHeight: '60px',
                  borderBottom: '1px solid #3B2D5F',
                }
              },
              pagination: {
                style: {
                  backgroundColor: '#1C1235',
                  color: 'white',
                  borderTop: '1px solid #3B2D5F',
                }
              }
            }}
          />
           <button
        className="fixed bottom-6 right-6 w-14 h-14 rounded-full bg-[#8F4EFF] hover:bg-purple-700 text-2xl flex items-center justify-center shadow-lg"
        onClick={() => navigate('/shifts/new')}
        style={{ marginBottom: '30px' }}
      >
        +
      </button>
        </div>
      {/* </div> */}

      {/* Modal for client detail */}
      {selectedClient && (
        <Modal
          isOpen={true}
          onRequestClose={() => setSelectedClient(null)}
          className="max-w-lg mx-auto mt-24 bg-[#1C1235] p-6 rounded-xl outline-none shadow-xl text-white"
          overlayClassName="fixed inset-0 bg-black bg-opacity-60 flex items-start justify-center z-50"
        >
          <h2 className="text-xl font-bold mb-4">{selectedClient.name}</h2>
          <p><strong>Phone:</strong> {selectedClient.phone}</p>
          <p><strong>Address:</strong> {selectedClient.address}</p>
          <p><strong>DOB:</strong> {selectedClient.dob}</p>
          <p><strong>NDIS:</strong> {selectedClient.ndisNumber}</p>
          <p><strong>About:</strong> {selectedClient.about}</p>
          <p><strong>Allergies:</strong> {selectedClient.allergies}</p>
          <p><strong>Medications:</strong> {selectedClient.medications}</p>
          <p><strong>Emergency Contact:</strong> {selectedClient.emergencyContact}</p>
          <p><strong>Goals:</strong> {selectedClient.goals}</p>
          <p><strong>Other Info:</strong> {selectedClient.otherInfo}</p>
          <p><strong>Plan Type:</strong> {selectedClient.planType}</p>
          {/* ✅ Safely parse and display documents */}
    {selectedClient.documents && (
      <p>
        <strong>Documents : </strong>
        {(Array.isArray(selectedClient.documents)
          ? selectedClient.documents
          : (() => {
              try {
                return JSON.parse(selectedClient.documents);
              } catch {
                return [];
              }
            })()
        ).map((doc, idx, arr) => (
          <a
            key={idx}
            href={`${API_BASE_URL}${doc.startsWith('/') ? '' : '/'}${doc}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-400 hover:text-purple-200"
          >
            Doc {idx + 1}{idx < arr.length - 1 ? ', ' : ''}
          </a>
        ))}
      </p>
    )}
    {/* {selectedClient.documents?.length > 1 && (
    <div className="space-y-1">
    <strong>Documents:</strong>
    {JSON.parse(selectedClient.documents).map((doc, idx) => (
      <div key={idx} className="flex items-center gap-1">
        <a
          href={`${API_BASE_URL}${doc}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-400 hover:text-purple-200"
        >{doc.split('-')[1] || doc}
        </a>
        <button
          onClick={() => handleDeleteDocument(selectedClient.id, doc)}
          className="text-red-500 text-sm hover:text-red-700"
        >
          🗑
        </button>
      </div>
    ))}
  </div>
)} */}


          <div className="text-right mt-4">
            <button
              onClick={() => setSelectedClient(null)}
              className="bg-red-600 hover:bg-red-700 px-4 py-2 rounded"
            >
              Close
            </button>
          </div>
        </Modal>
      )}
     
    </div>
  );
};

export default ClientList;
